ngOUC.config(function($locationProvider){
    $locationProvider.html5Mode(true);
});

